const grouppermissionsupervisor = (state = [], action) => {
    switch (action.type) {
      case 'HANDLE_GROUPS_PERMISSION_SUPERVISOR':
        return action.data
      default:
        return state
    }
  }
  
  export default grouppermissionsupervisor